import { Stack, Typography } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { Button } from '../../buttons';
import { Drawer, DrawerBody, DrawerContent, DrawerHeader } from '../../drawer';
import type { DrawerProps } from '../../drawer/types';
import { ArrowCounterClockwise } from '../../icons';
import type { DynamicGridItem } from '../types';
import { DynamicGridDrawerRow } from './DynamicGridDrawerRow';

export type DynamicGridDrawerProps = DrawerProps & {
  items: DynamicGridItem[];
  hiddenItems: Set<string>;
  toggleItemVisibility: (id: string) => void;
  title: string;
  onRestoreDefaults?: () => void;
};

export const DynamicGridDrawer = ({
  items,
  hiddenItems,
  toggleItemVisibility,
  title,
  onRestoreDefaults,
  ...props
}: DynamicGridDrawerProps) => (
  <Drawer size="small" testId="dynamic-grid-drawer" {...props}>
    <DrawerHeader>
      {onRestoreDefaults && (
        <Button
          size="sm"
          variant="ghost"
          startIcon={<ArrowCounterClockwise />}
          onClick={onRestoreDefaults}
          testId="restore-defaults-button"
          sx={{ ml: 'auto' }}
        >
          Restore default
        </Button>
      )}
    </DrawerHeader>
    <DrawerBody>
      <DrawerContent>
        <Typography variant="h5" mb={8}>
          {title}
        </Typography>
        <Typography
          variant="P12R"
          sx={{ color: tokens.theme.fg.structural.secondary }}
          mb={24}
        >
          Select the cards you want to display, then drag them on the dashboard
          to rearrange.
        </Typography>
      </DrawerContent>
      <Stack>
        {items.map((item) => (
          <DynamicGridDrawerRow
            key={item.id}
            item={item}
            visible={!hiddenItems.has(item.id)}
            onToggle={() => toggleItemVisibility(item.id)}
          />
        ))}
      </Stack>
    </DrawerBody>
  </Drawer>
);
